import * as types from '../constants/actionTypes';
import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function dropboxes(state = INITIAL_STATE, action) {
    switch (action.type) {

        case types.DROPBOXES__REQUESTED__SUCCEEDED: {
            const { dropboxes } = action.payload;

            return {
                ..._.mapKeys(dropboxes.entities, id)
            };
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/dropboxesReducer.js
 **/